import { isSuccessfulStatusCode } from '../../../helpers/api-ts/request'
import { authorizedFetch } from '../../helpers/authorizedFetch'
import trans from '../../helpers/trans'
import { generateApiV3Url } from '../../helpers/url'
import { FetchResult, FetchResultType } from '../FetchResult'
import {
    BaseScheduleShift,
    BaseScheduleShiftDetailResource,
    CreateBaseScheduleShiftRequest,
    PatchBaseScheduleShiftRequest,
} from './BaseScheduleShift'
import { transformBaseScheduleShiftDetail } from './BaseScheduleShiftTransformers'

export const getBaseScheduleShiftApiCall = async (
    baseScheduleShiftId: string,
): Promise<FetchResult<BaseScheduleShift, string>> => {
    try {
        const url = generateApiV3Url({ endpoint: `/base-schedule-shifts/${baseScheduleShiftId}` })

        const response = await authorizedFetch(url)

        if (! isSuccessfulStatusCode(response.status)) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            }
        }

        const data: BaseScheduleShiftDetailResource = await response.json()

        return {
            status: response.status,
            type: FetchResultType.Success,
            data: transformBaseScheduleShiftDetail(data),
        }
    } catch (error) {
        console.error('[getBaseScheduleShiftApiCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}

export const postBaseScheduleShiftApiCall = async (
    request: CreateBaseScheduleShiftRequest,
): Promise<FetchResult<BaseScheduleShift, string>> => {
    try {
        const url = generateApiV3Url({ endpoint: '/base-schedule-shifts' })

        const response = await authorizedFetch(url, {
            method: 'POST',
            body: JSON.stringify(request),
        })

        if (! isSuccessfulStatusCode(response.status)) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            }
        }

        const data: BaseScheduleShiftDetailResource = await response.json()

        return {
            status: response.status,
            type: FetchResultType.Success,
            data: transformBaseScheduleShiftDetail(data),
        }
    } catch (error) {
        console.error('[postBaseScheduleShiftApiCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}

export const patchBaseScheduleShiftApiCall = async (
    baseScheduleShiftId: string,
    request: PatchBaseScheduleShiftRequest,
): Promise<FetchResult<BaseScheduleShift, string>> => {
    try {
        const url = generateApiV3Url({ endpoint: `/base-schedule-shifts/${baseScheduleShiftId}` })

        const response = await authorizedFetch(url, {
            method: 'PATCH',
            body: JSON.stringify(request),
        })

        if (! isSuccessfulStatusCode(response.status)) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            }
        }

        const data: BaseScheduleShiftDetailResource = await response.json()

        return {
            status: response.status,
            type: FetchResultType.Success,
            data: transformBaseScheduleShiftDetail(data),
        }
    } catch (error) {
        console.error('[patchBaseScheduleShiftApiCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}

export const deleteBaseScheduleShiftApiCall = async (
    baseScheduleShiftId: string,
): Promise<FetchResult<boolean, string>> => {
    try {
        const url = generateApiV3Url({ endpoint: `/base-schedule-shifts/${baseScheduleShiftId}` })

        const response = await authorizedFetch(url, { method: 'DELETE' })

        if (! isSuccessfulStatusCode(response.status)) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            }
        }

        return {
            status: response.status,
            type: FetchResultType.Success,
            data: true,
        }
    } catch (error) {
        console.error('[deleteBaseScheduleShiftApiCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}
